import { canonicalTimeoutCategory } from './timeoutState';

// Admin values remain authoritative; aliases resolve to one existing category.
export const getPhase4CategoryOptions = (configured, fallback = []) => {
  const source = Array.isArray(configured) ? configured : fallback;
  const seen = new Set();
  const options = [];
  source.forEach(value => {
    const option = canonicalTimeoutCategory(String(value ?? '').replace(/\s+/g, ' ').trim());
    if (!option || option === 'Undisclosed/Timeout' || seen.has(option)) return;
    seen.add(option);
    options.push(option);
  });
  // Preserve the existing explicit Phase 4 manual-option rule.
  if (!seen.has('Undisclosed')) options.push('Undisclosed');
  return options;
};

// Resolve labels only through this dropdown's canonical taxonomy.
export const resolvePhase4Category = (value, options) => {
  if (typeof value !== 'string') return null;
  const normalized = canonicalTimeoutCategory(value.replace(/\s+/g, ' ').trim()).toLowerCase();
  const matches = options.filter(option => option.toLowerCase() === normalized);
  return matches.length === 1 ? matches[0] : null;
};
